import { render, staticRenderFns } from "./GridDinamicoNew.vue?vue&type=template&id=a9373982"
import script from "./GridDinamicoNew.vue?vue&type=script&lang=js"
export * from "./GridDinamicoNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports